import { createFeatureSelector, createSelector } from '@ngrx/store';
import { createApiCallSelectors } from 'src/app/common/store/generic.selectors';
import { ISubHeaderState } from './subheader.reducer';
import { subHeaderFeatureKey } from './type';

const subHeaderFeatureState =
  createFeatureSelector<ISubHeaderState>(subHeaderFeatureKey);

export const subHeaderSelectors = {
  getTriggerAction: createSelector(
    subHeaderFeatureState,
    (state: ISubHeaderState) => state.triggerAction
  ),
};
